export default "https://static-website.miro.com/miro-site-lp-build-assets/_next/static/chunks/fonts/formular-medium-df858b0185aa8bfe0733cb008d6b5f37.woff2";